









































import Component from 'vue-class-component';
import { Ref } from 'vue-property-decorator';

// The base for every input component
import InputBase from './Base.vue';

@Component
export default class InputCheckbox extends InputBase<boolean> {

    @Ref('checkbox')
    private checkbox!: HTMLInputElement;

    /**
     *  Keep track of the current checked state, in
     *  order to add the checked modifier class.
     */
    private mounted(): void {

        this.checkbox.checked = this.value;

    }

    /**
     *  Used to toggle the checkbox, if not disabled.
     */
    private toggle(): void {

        if (this.disabled) {

            return;

        }

        this.checkbox.checked = !this.checkbox.checked;

        this.onInput(this.checkbox.checked);

    }

}
